import { Component, OnInit ,ViewChild} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgbTimepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  
import { DomSanitizer} from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core'; 
@Component({
  selector: 'app-cv',
  templateUrl: './cv.component.html',
  styleUrls: ['./cv.component.scss']
})
export class CvComponent implements OnInit {
  @ViewChild('cexp',null) cexp;
  @ViewChild('cper',null) cper;
  @ViewChild('cgper',null) cgper;
  
  constructor(public authService: AuthService,
    public sanitizer:DomSanitizer, config: NgbTimepickerConfig,
    public router: Router) { 

      
    }

ngOnInit() {
  this.ls_persona();
  this.ls_area();  
}
rpt(itm){

}
upd_ls(){
  this.ls_persona();
}
hidCvePersona:any;
descipcion_cda:any;
descipcion_kdr:any;
descipcion_kpi:any;
descipcion_dke:any;
experience_:any;
exp={
  id:0,
  posicion:"",
  txdirRep1:"",
  txdirRep2:"",
  descripcion:"",
  departamento:""
}
btnmigrate:boolean=true;
msg_rolecard;
gdasa(){
  
}
get_experience(id_){
  this.exp.posicion="";
  this.exp.descripcion="";
  this.exp.departamento="";
  this._mAre1=0;
  let postData = {
    id:id_
  } 
  this.loading=true;
    //console.log(postData);
    this.authService.service("/api/get_experience",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.exp.id=res[0].id;
            this.exp.posicion=res[0].titulo;
            this.exp.descripcion=res[0].descripcion;
            this._mAre1=res[0].idarea1;
            this._mAre2=res[0].idarea2;
            this.exp.txdirRep1=res[0].txdirRep1;
            this.exp.txdirRep2=res[0].txdirRep2;
            this.exp.departamento=res[0].departamento;
            this.btnmigrate=false;
            this.msg_rolecard="";
          } else{
            this.msg_rolecard="Doesn't exist a Role Card linked";
            this.btnmigrate=true;
            //console.log("no hay role");
          }        
          this.loading=false; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });   
        this.loading=false;
}
bndJD:boolean=true;
bndcda:boolean=true;
bndkdr:boolean=true;
bndkpi:boolean=true;
bnddke:boolean=true;
bndnr:boolean=true;
bnddo:boolean=true;
p1;p2;p3;
c1;c2;c3;c4;c5;c6;c7;c8;c9;c10;
c11;c12;c13;c14;c15;c16;
v_assesment(itm){
  //console.log(itm);
this.persona.id=itm.id;
this.persona.nombre=itm.nombre
this.persona.paterno=itm.apaterno;
this.persona.materno=itm.amaterno;
this.p1="";this.p2="";this.p3="";         
this.c1=0;this.c2=0;this.c3=0;this.c4=0;this.c5=0;this.c6=0;this.c7=0;this.c8=0;this.c9=0;this.c10=0;   
this.c11=0;this.c12=0;this.c13=0;this.c14=0;this.c15=0;this.c16=0;   
let postData = {  
  id_persona:itm.id
  
}
//console.log(postData);
this.authService.service("/api/get_evaluacion_dpi",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);                                
      this.loading=false;
      if(res.length>0){
        this.p1=res[0].p1;this.p2=res[0].p2;this.p3=res[0].p3;         
        this.c1=res[0].c1;this.c2=res[0].c2;this.c3=res[0].c3;this.c4=res[0].c4;this.c5=res[0].c5;this.c6=res[0].c6;this.c7=res[0].c7;this.c8=res[0].c8;this.c9=res[0].c9;this.c10=res[0].c10;   
        this.c11=res[0].c11;this.c12=res[0].c12;this.c13=res[0].c13;this.c14=res[0].c14;this.c15=res[0].c15;this.c16=res[0].c16;   
      }
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        this.loading=false;
        swal.fire('¡API incorrecta! get_evaluacion_dpi', '', 'error');
  }); 
}
gda_assesment(){  
  this.loading=true;
  let postData = {
    id_persona:this.persona.id,
    p1:this.p1,p2:this.p2, p3:this.p3,    
    c1:this.c1,c2:this.c2,c3:this.c3,c4:this.c4,c5:this.c5,c6:this.c6,c7:this.c7,c8:this.c8,c9:this.c9,c10:this.c10,
    c11:this.c11,c12:this.c12,c13:this.c13,c14:this.c14,c15:this.c15,c16:this.c16,
  } 
    //console.log(postData);
    this.authService.service("/api/gda_evaluacion_dpi",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                                
          this.loading=false;   
          swal.fire('ok', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
            swal.fire('¡API incorrecta! gda_evaluacion_dpi', '', 'error');
      });  
}
limpia_role(){
  this.bndJD=false;
  this.bndcda=false;
  this.bndkdr=false;
  this.bndkpi=false;
  this.bnddke=false;
  this.bndnr=false;
  this.bnddo=false;
  
}
descipcion_nr1;
descipcion_nr2;
descipcion_do1;

show__(t){
  switch(t){
    case 'nr':
      if(this.bndnr==true){
        this.limpia_role();
      }else{
        this.limpia_role();
        this.bndnr=true;
      }
      break;
    case 'do':
      if(this.bnddo==true){
        this.limpia_role();
      }else{
        this.limpia_role();
        this.bnddo=true;
      }
        break;
    case 'jd':      
      if(this.bndJD==true){
        this.limpia_role();
      }else{
        this.limpia_role();
        this.bndJD=true;
      }
      break;
    case 'cda':
      if(this.bndcda==true){
        this.limpia_role();
      }else{
        this.limpia_role();
        this.bndcda=true;
      }
      break;
    case 'kdr':
      if(this.bndkdr==true){
        this.limpia_role();
      }else{
        this.limpia_role();
        this.bndkdr=true;
      }   
      break;
    case 'kpi':
      if(this.bndkpi==true){
        this.limpia_role();
      }else{
        this.limpia_role();
        this.bndkpi=true;
      }
      break;
    case 'dke':
      if(this.bnddke==true){
        this.limpia_role();
      }else{
        this.limpia_role();
        this.bnddke=true;
      }
      break;
  }

}
fn_format(itm,t){
  switch (Number(t)) {
    case 1:case 2:
      this.hidCvePersona=itm.id;
      localStorage.setItem("id_persona",this.hidCvePersona);
      localStorage.setItem("tprint",t);
      this.router.navigate([]).then(result => {  window.open('./#/fmt112', '_blank'); });          
      break;  
    default:
      this.hidCvePersona=itm.id;
      localStorage.setItem("id_persona",this.hidCvePersona);
      localStorage.setItem("tprint",t);
      this.router.navigate([]).then(result => {  window.open('./#/role', '_blank'); });  
      break;
  }
  //console.log(itm);
  
 // this.print();
}
print(){
  localStorage.setItem("id_persona",this.hidCvePersona);
  this.router.navigate([]).then(result => {  window.open('./role', '_blank'); });
}


del_reportto(itm){
  //console.log("del_reportto");
  let postData = {
    id:itm.id} 
    //console.log(postData);
    this.authService.service("/api/del_reportto",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.get_reportto(this.hidCvePersona);
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! gdareportto', '', 'error');
        });   

}
gda_reportto(){
  this.loading=true;
  let postData = {
    id_persona:this.hidCvePersona,
    id_report:this._mAre2 } 
    //console.log(postData);
    this.authService.service("/api/gda_reportto",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          
          this.get_reportto(this.hidCvePersona);                  
          this.loading=false;   
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
            swal.fire('¡API incorrecta! gdareportto', '', 'error');
        });   

}
reportto:any;
get_reportto(cve){
  this.reportto=[];
  //console.log("reporto");
  let postData = {
    id_persona:cve } 
    //console.log(postData);
    this.loading=true;
    this.authService.service("/api/get_reportto",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                        
          this.reportto=data;
          this.loading=false;           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
            swal.fire('¡API incorrecta! reportto', '', 'error');
        });   


}

gda_exp(){
  //console.log("aqui ");
  let postData = {
    id_persona:this.hidCvePersona,
    descripcion:this.exp.descripcion,
    titulo:this.exp.posicion,
    departamento:this.exp.departamento,
    area1:this._mAre1,
    area2:this._mAre2
  } 
  this.loading=true;
    //console.log(postData);
    this.authService.service("/api/gda_experience",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
       
            
            this.ls_area();
            this.get_reportto(this.hidCvePersona);
            swal.fire('Success ok', '', 'success');
            this.loading=false; 
            this.cexp.nativeElement.click();          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! gexp', '', 'error');
            this.loading=false;           
        });   
}
  
ins_cda(){
  if(this.descipcion_cda==undefined || this.descipcion_cda=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    descripcion:this.descipcion_cda
  } 
    //console.log(postData);
    this.authService.service("/api/ins_cda",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_cda(this.hidCvePersona);
            this.descipcion_cda="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
ins_kdr(){
  if(this.descipcion_kdr==undefined || this.descipcion_kdr=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    descripcion:this.descipcion_kdr
  } 
    //console.log(postData);
    this.authService.service("/api/ins_kdr",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_kdr(this.hidCvePersona);
            this.descipcion_kdr="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        }); 
}
ins_kpi(){
  if(this.descipcion_kpi==undefined || this.descipcion_kpi=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    descripcion:this.descipcion_kpi
  } 
    //console.log(postData);
    this.authService.service("/api/ins_kpi",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_kpi(this.hidCvePersona);
            this.descipcion_kpi="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        }); 
}
ins_dke(){
  if(this.descipcion_dke==undefined || this.descipcion_dke=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    descripcion:this.descipcion_dke
  } 
    //console.log(postData);
    this.authService.service("/api/ins_dke",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_dke(this.hidCvePersona);
            this.descipcion_dke="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        }); 
}
del_cda(itm){
  let postData = {
    id:this.hidCvePersona
  } 
    //console.log(postData);
    this.authService.service("/api/del_cda",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_cda(this.hidCvePersona);
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
del_kdr(itm){
  let postData = {
    id:this.hidCvePersona

  } 
    //console.log(postData);
    this.authService.service("/api/del_kdr",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_kdr(this.hidCvePersona);
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        }); 
}
del_kpi(itm){
  let postData = {
    id:this.hidCvePersona
  } 
    //console.log(postData);
    this.authService.service("/api/del_kpi",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_kpi(this.hidCvePersona);
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        }); 
}
del_dke(itm){
  let postData = {
    id:this.hidCvePersona
  } 
    //console.log(postData);
    this.authService.service("/api/del_dke",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_dke(this.hidCvePersona);
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        }); 
}
url:any="/org";
fn_chart(itm){
  /*/this.get_experience(itm.id);  
  //this.get_reportto(itm.id)
  this.persona.id=itm.id;
  this.persona.foto=itm.foto;
  this.persona.nombre=itm.nombre;
  this.persona.paterno=itm.apaterno;
  this.persona.materno=itm.amaterno;
  this.persona.profesion=itm.profesion;*/
  localStorage.setItem("menu_","0");  
  this.router.navigate(["/org"]);
  //this.url=this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  
}
pdwe="";
pdwe_;
del_pdwe(itm){
  let postData = {
    id:itm.id
  } 
  //console.log(postData);
  this.authService.service("/api/del_pdwe",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_phyd();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
      }); 
}
ins_pdwe(){
  if(this.pdwe==undefined || this.pdwe=="")return ;
  let postData = {
    id_per:this.persona.id,
    des:this.pdwe
  } 
  console.log(postData);
  this.authService.service("/api/ins_pdwe",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_phyd()       ;
        this.pdwe="";
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
      }); 
}   
ls_phyd(){
  let postData = {
    id_per:this.persona.id
  } 
  console.log(postData);
  this.authService.service("/api/get_pdwe",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.pdwe_=data;         
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
      }); 
}
vht(itm){
  console.log(itm);
  this.persona.id=itm.id;
  this.persona.id_role=itm.id_role;
  this.persona.nombre=itm.nombre
  this.persona.paterno=itm.apaterno;
  this.persona.materno=itm.amaterno;
  this.ls_ht();
}
ht=Array();
rpt_ht(itm){
  localStorage.setItem("t_ht","P");
  localStorage.setItem("id_ht",itm.id);
  console.log(itm)
  this.router.navigate([]).then(result => {  window.open('./fmtht', '_blank'); }); 

}
ls_ht(){
  let postData = {
    id_role:this.persona.id_role
  } 
  this.ht=[];
  console.log(postData);
  this.authService.service("/api/get_ht_role",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        for(var i=0;i<res.length;i++){
          this.ht.push({idx:(i+1),nombre:res[i].nombre,id:res[i].id});
        }
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta!', '', 'error');
      }); 
}
v_phyde(itm){
  this.persona.id=itm.id;
  this.persona.nombre=itm.nombre
  this.persona.paterno=itm.apaterno;
  this.persona.materno=itm.amaterno;
  this.ls_phyd();
}
fmt_assesment(){
  localStorage.setItem("id_persona",this.persona.id.toString());  
  localStorage.setItem("tpo","X");  
  console.log(this.persona);
  localStorage.setItem("nombre",this.persona.nombre+" "+this.persona.paterno+" "+this.persona.materno)  
  this.router.navigate([]).then(result => {  window.open('./assesment', '_blank'); });          
}
bndDepa=false;
role_card(itm){
  //console.log(itm);
  //console.log("rolecard");
  if (itm.director==1){
    this.bndDepa=true;
  }else{
    this.bndDepa=false;
  }
  this.ls_area();
  this.migrate=1;
  this.v_role=true;
  this.exp.departamento="";
  this.exp.posicion="";
  this.exp.descripcion="";
  this.exp.txdirRep1="";
  this.exp.txdirRep2="";
  this._mAre1=0;
  this._mAre2=0;
  this.show__('jd');
  this.bndJD=true;
  this.are1=true;
  this.are2=true;  
  this.persona.id=itm.id;
  this.persona.foto=itm.foto;
  this.persona.nombre=itm.nombre;
  this.persona.paterno=itm.apaterno;
  this.persona.materno=itm.amaterno;
  this.persona.profesion=itm.profesion;
  this.hidCvePersona=itm.id;
  this.cda=[];
  this.kdr=[];
  this.kpi=[];
  this.dke=[];
  this.get_reportto(itm.id)
  this.ls_cda(itm.id);
  this.ls_kdr(itm.id);
  this.ls_kpi(itm.id);
  this.ls_dke(itm.id);
  this.get_experience(itm.id);
}  
ls_cda(id_){
    let postData = {id:id_} 
    //console.log(postData);
    this.authService.service("/api/get_cda",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.cda=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  ls_kdr(id_){
    let postData = {id:id_  } 
    //console.log(postData);
    this.authService.service("/api/get_kdr",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kdr=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  ls_kpi(id_){
    let postData = {id:id_ } 
    //console.log(postData);
    this.authService.service("/api/get_kpi",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kpi=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  ls_dke(id_){
    let postData = { id:id_ } 
    //console.log(postData);
    this.authService.service("/api/get_dke",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.dke=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }  
  n_are1(){
    this.are1=false;
  }
  n_are2(){
    this.are2=false;
  }
  cda:any;
  kdr:any;
  kpi:any;
  dke:any;
  
  are1:boolean=true;
  are2:boolean=true;
  _mAre1:number=0;
  _mAre2:number=0;
  sel1(id:number){
    if(id==-1){
      this.are1=false;
    }
  }
  sel2(id:number){
    if(id==-1){
      this.are2=false;
    }
  }
  per:any;
  comp_desirable;
  tipo_c;
  dc_caliper(){
    this.migrate=1;
    this.tpd_C=true;
    this.tipo_c="D.J.C.";
    this.ls_competencias_caliper()
    this.v_role=false;
    this.comp_desirable=[];
    let postData = {
        id_role_card:this.exp.id
    } 
    //console.log(postData);
    this.authService.service("/api/get_competence_caliper_desirable",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.comp_desirable=data; 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
 
  }
  v_role:boolean=true;
  role_(){
    this.migrate=1;
    this.v_role=true;
  }
  hidpercompetencia;
  edit_eval_desir(itm){
    this.tpd_C=false;
    //console.log(itm);
    this.hidpercompetencia=itm.id;
    this.selComp_desirable=itm.id_competencia;
    this.eval_desirable=itm.evaluacion;
  }
  tpd_C:boolean=true;
  upd_competencia_desirable(){
    let postData = {
      id_percompetencia:this.hidpercompetencia,
      evaluacion:this.eval_desirable};
    if(this.selComp_desirable==0)return;
    this.authService.service("/api/upd_percompetencia_desirable",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.ls_percompetencias_t();
          if(this.tipo_c=="CALIPER"){
            this.dc_caliper();
          }else{
            this.dc_trinity();
          }
          
          this.competence_v_t=true;
          swal.fire('Ok', '', 'success');
  
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('API incorrecta!', '', 'error');
        });
  }
  dc_trinity(){
    this.migrate=1;
    this.tipo_c="D.P.C.";
    this.ls_competencias_trinity()
    this.v_role=false;
    this.tpd_C=true;
    this.comp_desirable=[];
    let postData = {
      id_role_card:this.exp.id
    } 
    //console.log(postData);
    this.authService.service("/api/get_competence_trinity_desirable",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.comp_desirable=data;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
    
  }
  valida_per2(){
    if(this.persona.nombre==undefined){
      swal.fire('Name Incomplete!', '', 'error');
      return false;
    }

    if(this.persona.paterno==undefined && this.persona.paterno==""){
      swal.fire('Fathers Surname Incomplete!', '', 'error');
      return false;
    }
    
    if(this.persona.profesion==undefined){
      //swal.fire('Profession Incomplete!', '', 'error');
      //return false;
    }
    if(this.role_name==undefined){
      swal.fire('Field Role Incomplete!', '', 'warning');
      return false;
    }
    return true;
  }
  
  valida_per(){
    if(this.persona.nombre.length==0){
      swal.fire('Name Incomplete!', '', 'error');
      return false;
    }
    if(this.persona.paterno.length==0){
     // swal.fire('Surname Incomplete!', '', 'error');
     // return false;
    }
    
    if(this.persona.profesion.length==0){
      //swal.fire('Profession Incomplete!', '', 'error');
      //return false;
    }
    if(this.persona.foto.length==0){
      //return false;
    }
    return true;
  }
   persona={
    id:0, 
    id_role:0, 
    foto:"",
     nombre:"",
     paterno:"",
     materno:"",
     profesion:"",
     fec_ingreso:"",     
     chart:0
   };
   
   nvo_reg(){
     
    this.msg_foto="";
    this.persona.chart=0;
    this.persona.foto="";
    this.persona.nombre="";
    this.persona.paterno="";
    this.persona.materno="";
    this.persona.fec_ingreso="";
    this.persona.profesion="";     
    this.tpoacper=true;
    try {
      this.image_file=undefined;
      this.fileToUpload=null  
    } catch (error) {      
    }
    
    
   }
  
   tpoacper:boolean=true;
   
   @ViewChild('image_file',null) image_file;
   fn_edit(itm){
    try {
      this.image_file=undefined;  
      this.fileToUpload=null  
    } catch (error) {      
    }
    this.msg_foto="";
    this.persona.chart=0;
    this.persona.chart=itm.director;
    this.persona.id=itm.id;
    try {
      this.persona.fec_ingreso=itm.ingreso.toString().substring(0,10);  
    } catch (error) {
      this.persona.fec_ingreso="";
    }    
    this.persona.foto=itm.foto;
    this.persona.nombre=itm.nombre;
    this.persona.paterno=itm.apaterno;
    this.persona.materno=itm.amaterno;
    this.persona.profesion=itm.profesion; 
   this.tpoacper=false;
  }
  valida_exp() {
    return true;
  }
  gdaexp(){
    //console.log("algo");
    if (this.valida_exp()==true){
      let postData = {
        
      } 
      //console.log(postData);
      this.authService.service("/api/ins_exp",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
              swal.fire('ok', '', 'success'); 
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });
    }
  }
  add_p;
  fn_add_p(c){
    this.add_p=c;
  }
  add_other(){
    this.migrate=4;
    this.persona.nombre=""
    this.persona.paterno=""
    this.persona.materno=""
    this.persona.foto=""

    this.v_role=false;
    this.add_p=0;
  }
  can_pfpps(cve){
    let postData = {
      id_pfpps:cve
    }       
    //console.log(postData);
    this.authService.service("/api/del_pfpps",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('ok', '', 'success');
          let dat_={id:this.persona.id};
          this.pfp_ps(dat_);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  
  }
  updper(){
    this.loading=true;
    
    if (this.valida_per()==true){
      //console.log('per');
      let postData = {
        id:this.persona.id,
        nombre:this.persona.nombre,
        paterno:this.persona.paterno,
        materno:this.persona.materno,
        profesion:this.persona.profesion,
        ingreso:this.persona.fec_ingreso,
        foto:this.persona.foto,
        chart:Number(this.persona.chart),
        

      }       
      this.hidCvePersona=this.persona.id;
      //console.log(postData);
      this.authService.service("/api/upd_persona",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
            this.uploadFileToActivity();
            
            swal.fire('ok', '', 'success');
            this.cgper.nativeElement.click();
            //console.log("--");
            this.per=[];
            this.upd_ls(); 
            this.loading=false;
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
              this.loading=false;
          });
    }

  }
  gda_reportto_catalog(itm){
    let postData = {      
      report:this.exp.id,
      id_persona:itm.id
    } 
    this.authService.service("/api/ins_persona3",postData)
    .then(
        data => {
          swal.fire('ok', '', 'success');
           this.get_reportto(this.hidCvePersona);
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  role_name;
  gdaper2(){
    //console.log(this.exp);
    //console.log(this.persona);
    if (this.valida_per2()==true){
      let postData = {
        nombre:this.persona.nombre,
        paterno:this.persona.paterno,
        materno:this.persona.materno,
        role:this.role_name,
        report:this.exp.id,
        id_cliente:localStorage.getItem("id_cliente"),
        chart:this.persona.chart
      } 
      //console.log(postData);
      this.authService.service("/api/ins_persona2",postData)
      .then(
          data => {
           swal.fire('ok', '', 'success');
           this.upd_ls();

          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!'+de, '', 'error');
          });
    }
  }
  public loading:Boolean=false;
  gdaper(){
    this.loading=true;
    if (this.valida_per()==true){
      let postData = {
        nombre:this.persona.nombre,
        paterno:this.persona.paterno,
        materno:this.persona.materno,
        profesion:this.persona.profesion,
        ingreso:this.persona.fec_ingreso,
        foto:this.persona.foto,
        id_cliente:localStorage.getItem("id_cliente"),
        chart:this.persona.chart
      } 
      
      //console.log(postData);
      this.authService.service("/api/ins_persona",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
              //console.log("insper");
              //console.log(data[0][0].id);
              this.hidCvePersona=data[0][0].id;
              this.uploadFileToActivity();              
              swal.fire('ok', '', 'success');
              this.loading=false;
              this.cgper.nativeElement.click();
              this.upd_ls()
            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta!', '', 'error');
          });
    }
    this.loading=false;
  }
  
  ins_area(postData){
    this.authService.service("/api/ins_area",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {        
          this.ls_area();
          this.exp.txdirRep1="";
          this.exp.txdirRep2="";
          if (res[0][0].idarea1>0)
          this._mAre1=res[0][0].idarea1;
          this.get_reportto(this.hidCvePersona);  
          this.get_experience(this.hidCvePersona);
          this.ls_persona();
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });  

  }
  we_=[{}];
  we={
    anio:0,
    empresa:"",
    descripcion:""
  };
  fn_delper(itm){
    let postData = {
      id_persona:itm.id
    } 
    if (!confirm("The data will be saved!"))
    return;

    //console.log(postData);
    this.authService.service("/api/del_per",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
                     
          } 
          this.ls_persona();
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! delper', '', 'error');
        });

  }
  gda_pfpps(itm,t){
    //console.log("gda_pfpps");
    //console.log(itm)
    let postData = {
      tpo:t,
      id_persona:itm.id,
      id_role2:itm.id_role,
      id_role:this.id_role
    }
    //console.log
    //console.log(postData);
    this.authService.service("/api/gda_pfpps",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this._busper=res;
          let dat_={id:this.persona.id};
          this.pfp_ps(dat_);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  pfpps;
  v_pfpps:boolean=true;
  nvo_pfpps(){
    this.v_pfpps=false;
  }
  txtbusper="";
  _busper;
  bus_pfpps(){
    this._busper=[];
    
    let postData = {
      id_role:this.id_role,   
    persona:this.txtbusper,
    id_cliente:localStorage.getItem("id_cliente")
  }
  //console.log("bus_pfpps");
  //console.log(postData);
    this.authService.service("/api/bus_persona",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          //console.log(res);
          this._busper=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });

  }
  load_persona(itm){
    //console.log(itm);
    this.persona.id=itm.id;
    
    this.persona.foto=itm.foto;
    this.persona.nombre=itm.nombre;
    this.persona.paterno=itm.apaterno;
    this.persona.materno=itm.amaterno;
    this.persona.profesion=itm.profesion;
    //this.persona.role_id=itm.role;
  }
  id_role;
  ls_pfpps(itm){
    this.persona.nombre=itm.nombre;
    this.load_persona(itm);
    this.id_role=itm.id_role; 
    this.pfp_ps(itm);
  }
  pfp_ps(itm){    
    //console.log(itm);    
    this.v_pfpps=true;
    let postData = {
      id_persona:itm.id,
    }    
    //console.log(postData);
    this.authService.service("/api/get_pfpps",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.pfpps=res;
          //console.log(res);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });

  }
  txteducation:string="";
  txtgrado="";
  edu;
  get_education(cve){
    let postData = {
      id_persona:this.hidCvePersona,
    } 
    //console.log(postData);
    this.authService.service("/api/get_educacion",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.edu=res;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  txtanio_:Number=2021;
  gda_education(){
    this.loading=true;
    //console.log(this.txteducation);
    if(this.txteducation==null && this.txteducation==undefined)return;
    let postData = {
      id_persona:this.hidCvePersona,
      anio:Number(this.txtanio_),
      descripcion:this.txteducation,
      escuela:this.txtgrado
    } 
    //console.log(postData);
    this.authService.service("/api/gda_educacion",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
                     
          } 
          this.txteducation="";
          this.txtgrado="";
          this.get_education(this.hidCvePersona); 
          this.loading=false 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false 
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  del_educacion(itm){
    let postData = {
      id:itm.id
    }
    this.loading=true 
    this.authService.service("/api/del_educacion",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          
            this.get_education(this.hidCvePersona); 
            this.loading=false;   
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
            this.loading=false;
        });

  }
  
  gda_we(){
    //console.log(this.hidCvePersona);
    let postData = {
      anio:Number(this.txtanio),
      id_persona:this.hidCvePersona,
      descripcion:this.we.descripcion,
      empresa:this.we.empresa
    } 
    this.loading=true;
    //console.log(postData);
    this.authService.service("/api/gda_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
                     
          } 
          this.get_we(this.hidCvePersona); 
          this.loading=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
            this.loading=false;
        });
  }
  fn_we(itm){
    this.persona.nombre=itm.nombre;
    this.we.empresa="";
    this.we.anio=null;
    this.we.descripcion="";
    this.hidCvePersona=itm.id;
    this.get_we(itm.id);
  }
  fn_edu(itm){
    this.persona.nombre=itm.nombre;
    this.txteducation=""
    this.txtanio_=0;
    this.edu=[];
    this.hidCvePersona=itm.id;
    this.get_education(itm.id);
  }
  txtanio:any;
  del_we(itm){
    let postData = {
      id:itm.id
    }
    this.authService.service("/api/del_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('¡Ok!', '', 'success');
          this.get_we(this.hidCvePersona); 
                    
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });

  }
  migrate:Number=2;
  roles;
  get_role(){
    this.migrate=3;
    let postData = { };
    this.authService.service("/api/get_roles_unlinked",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.roles=res;
            
                    
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });

  }

  link_role(itm){    
    let postData = {
      id_role:itm.id,
      id_persona:this.persona.id
     };
    this.authService.service("/api/link_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          swal.fire('¡Ok!', '', 'success');
          this.migrate=1;
          this.get_reportto(this.persona.id)
          this.ls_cda(this.persona.id);
          this.ls_kdr(this.persona.id);
          this.ls_kpi(this.persona.id);
          this.ls_dke(this.persona.id);
          this.get_experience(this.persona.id);
          this.cda(this.persona.id);
          this.kdr(this.persona.id);
          this.dke(this.persona.id);
          this.kpi(this.persona.id);
          this.ls_persona();
         
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  unlink_role(){    
    this.migrate=2;
    this.v_role=false;
    //console.log(this.migrate);


  }
  cancel_migrate(){
    this.migrate=1;
  }
  migrate_confirm(tpo){
    let postData={
      role_id:this.exp.id,
      tpo_unink:tpo
    };
    this.authService.service("/api/unlink",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);    
          swal.fire('¡Ok!', '', 'success');      
          this.migrate=1;
          this.v_role=true;
          this.get_experience(this.persona.id);
          this.dke=[];
          this.kpi=[];
          this.cda=[];
          this.kdr=[];
          this.ls_persona();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  get_we(cve){
    this.hidCvePersona=cve;
    let postData = {
      id_persona:cve
    }
    this.authService.service("/api/get_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                       
          this.we_=data;          
                   
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });

  }
  can_are1(){
    this.are1=true;
  }
  can_are2(){
    this.are2=true;
  }
  gda_are1(){
    let postData = {area:this.exp.txdirRep1,id_persona:this.hidCvePersona,depend:0}
    this.ins_area(postData);
    this.are1=true;    
  }
  gda_are2(){
    //console.log("are2");
    let postData = {area:this.exp.txdirRep2,id_persona:this.hidCvePersona,depend:1}
    this.ins_area(postData);
    this.are2=true;
    
  }

  area:any;
  ls_area(){
    let postData = {
      id_raci:0,
      id_cliente:localStorage.getItem("id_cliente")
    }
    //console.log(postData);
    this.authService.service("/api/get_role",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          //console.log(res);
          this.area=data;         
                       
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });  

}
hidid_goal:number=0;
goal_e:boolean=false;
ev_goals:number=0;
del_evaluate_goal(itm){
  if(confirm("Confirm to delete this row?")==false)return;
  let postData = {
    id:itm.id   
  }
  
  this.authService.service("/api/del_goal",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);              
      this.ls_goals();
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('API incorrecta!', '', 'error');
    });  
}
evaluate_goal(itm){
  
  this.hidid_goal=itm.id;
  this.txtdescgoals="";
  this.ev_goals=0;
  /*
  this.txtdescgoals=itm.descripcion;
  this.ev_goals=itm.evaluacion;
  */
  this.goal_v=true;
  this.goal_e=true;
  this.goal_n=false;
  this.bndgoal_hk=false;
}
lista_gaol(){
  this.goal_v=false;
  this.goal_e=false;
}
goals;

txtgoals:any;
txtdescgoals:any;
goal_n:boolean=false;
goal_v:boolean=false;
bndgoal_hk:boolean=false;
metashk=[];
fn_nvo_goal(){
  this.goal_v=true;
  this.bndgoal_hk=false;
  this.goal_n=true;
  this.id_evlhk=0;
}
fn_nvo_goal_hk(){
  //this.metashk.push({id:1,hk:"ok",nombre:"12"})
  let postData = {
    id_role:this.id_role
  };
  console.log(postData);
  this.authService.service("/api/metas_hk",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);       
        this.metashk=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });    

  
  this.goal_v=true;
  this.bndgoal_hk=true;
  this.goal_e=false;
  this.goal_n=false;
}
fn_goals(itm){
  this.id_role=itm.id_role;
  this.persona.nombre=itm.nombre;
  this.goal_e=false;
  this.goal_v=false;
  console.log(itm);
  this.hidCvePersona=itm.id;
  this.txtgoals="";
  this.ls_goals();
}
date_goal:any;

gdahk_goals(){
  let postData = {
    id_goal:this.hidid_goal,
    evaluacion:this.ev_goals,
    id_evaluador:localStorage.getItem("usuario"),
    
    descripcion:this.txtdescgoals
  };
  //console.log(postData);
  this.authService.service("/api/ins_evalgoalshk",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('Ok', '', 'success');
        this.ls_goals();        
        this.goal_v=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });    
}
upd_goals(){
  let postData = {
    id_goal:this.hidid_goal,
    goal:this.txtgoals,
    evaluacion:this.ev_goals,
    descripcion:this.txtdescgoals
  };
  this.authService.service("/api/upd_goals",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('Ok', '', 'success');
        this.ls_goals();        
        this.goal_v=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });    
}
id_evlhk=0;
_evalgoalhk=[];
despliegue(itm){
  this.router.navigate(['fmtdespliegue']); 

}
evalgoalhk(itm){
  let postData = {  
    id_goal:itm.id
  };
  console.log("evalgoalhk");
  console.log(postData);
  this.authService.service("/api/get_evalgoalshk",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //swal.fire('Ok', '', 'success');
        console.log(this._evalgoalhk);
        this._evalgoalhk=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });    

}
rpt_hk(itm){
  console.log(itm)
  localStorage.setItem("t_hk","X");
  localStorage.setItem("nivel","1");
  localStorage.setItem("duenio_id",this.id_role);
  localStorage.setItem("duenio","");
  localStorage.setItem("fecha","");
  localStorage.setItem("superv","");
  localStorage.setItem("id_hk",itm.id_hk);
  this.router.navigate([]).then(result => {  window.open('./#/fmt_hk', '_blank'); }); 

}
insall_goal_hk(){
  let postData = {
    id_persona:this.id_role,
    
  };
  console.log(postData);
  this.authService.service("/api/ins_allgoals",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('Ok', '', 'success');
        this.ls_goals();        
        this.goal_v=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  

}
ins_goal_hk(itm){
  this.id_evlhk=itm.id;
  this.txtgoals="[HK]-"+itm.nombre;
  this.bndgoal_hk=false;
  this.goal_n=true;
}
ins_goals(){
  let postData = {
    id_persona:this.hidCvePersona,
    goal:this.txtgoals,
    fecha:this.date_goal,
    id_hk:this.id_evlhk
  };
  this.authService.service("/api/ins_goals",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('Ok', '', 'success');
        this.ls_goals();        
        this.goal_v=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });    
}
org;
  duenio_id_n1=0;
  duenio_id_nr="";
  
  responsable=0;
  responsable2=0;
  despliegue_=[];
  proyecto=0;
  id_hk=0;
ls_goals_hk(){  
  let postData = {
    id_cliente:localStorage.getItem("id_cliente")
  }       
  this.authService.service("/api/get_org",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.org=data;
        var bnd=0;
        for(var i=0;i<this.org.length;i++){              
          if(this.org[i].director==1){
            if(bnd==0){               
              this.duenio_id_n1= this.org[i].id_role;  
              bnd=1;
            }
          }              
        }  
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! exp', '', 'error');
      });                
      let postData2 = {
        id_hk:this.proyecto,
        usu:this.id_role,
        id_responsable:this.id_role
      }      
      var api="/api/despliegue_usu";
      if(this.duenio_id_n1==this.id_role){        
        api="/api/despliegue_resp";
      }
      this.authService.service(api,postData)
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);  
          this.despliegue_=res;          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });
  
  

}
ls_goals(){
  let postData = {
    id_persona:this.hidCvePersona
  };
  //console.log(postData);
  this.authService.service("/api/get_goals",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        
        this.goals=data;
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! goal', '', 'error');
      });    
}
cancel_nvoidp(){
  this.idp_v=true;
}
fn_nvo_idp(){
  this.idp_.id=0;
  this.idp_.skill=0;
  this.idp_.trainig="";
  this.idp_.fecha="";
  this.idp_.costos=0;
  this.idp_.resultados="";
  this.idp_.estatus="A";

  this.idp_v=false;
  this.idp_a=false;
}
idp_area:boolean=false;
feed_area:boolean=false;
feed_v:boolean=true;
feedb;
feed={
  id:0,
  periodo:0,
  evaluacion:0,
  descripcion:""
};
a_feed:boolean=true;
fn_edit_feed(itm){
  this.feed.id=itm.id;
  this.feed.descripcion=itm.descripcion;
  this.feed.evaluacion=itm.evaluacion;
  this.feed.periodo=itm.periodo;
  this.feed_v=false;
  this.a_feed=false;
}
fn_can_feedb(){
  this.feed_area=false;
  this.idp_area=true;
}
upd_feed(){
  let postData = {
    id_idp:this.feed.id,
    periodo:this.feed.periodo,
    evaluacion:this.feed.evaluacion,
    descripcion:this.feed.descripcion
  };
  
  this.authService.service("/api/upd_feed",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('Ok', '', 'success');
        this.ls_feed(this.hidcve_idp);
       this.ls_idp(this.hidCvePersona);
       this.feed_v=true; 
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! upd-feed', '', 'error');
      });    

}
ins_feed(){
  let postData = {
    id_idp:this.hidcve_idp,
    periodo:this.feed.periodo,
    evaluacion:this.feed.evaluacion,
    descripcion:this.feed.descripcion
  };
  //console.log(postData);
  this.authService.service("/api/ins_feed",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        swal.fire('Ok', '', 'success');
       this.ls_feed(this.hidcve_idp);
       this.ls_idp(this.hidCvePersona);
       this.feed_v=true; 
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! ins-feed', '', 'error');
      });    
}
fn_nvo_feedb(){
  this.feed_v=false;
  this.a_feed=true;
  this.hidcve_feed=0;
  this.feed.periodo=0;
  this.feed.evaluacion=0;
  this.feed.descripcion="";
}
fn_cancel_feedb(){
  this.feed_v=true;
}

ls_feed(id){
  let postData = {
    id_idp:id
  };
  this.authService.service("/api/get_feed",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.feedb=data;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });    
}
hidcve_feed;
hidcve_idp;
feed_name;
fn_feed_idp(itm){
  //console.log(itm)
  this.feed_name=' { '+itm.competencia + ' \ ' + itm.periodo_+' }';
  this.hidcve_idp=itm.id;
  this.ls_feed(itm.id);
  this.feed_area=true;
  this.feed_v=true;
  this.idp_area=false;
}
idp;
fn_idp(itm){
  this.hidCvePersona=itm.id; 
  this.persona.nombre=itm.nombre;
  //console.log(itm);
  this.idp=[];
  this.ls_idp(itm.id);  
  this.ls_competencias();
  this.idp_v=true;
  this.feed_area=false;
 this.idp_area=true;
}
valida_idp(){
  return true;
}
fn_updidp(){
if(this.valida_idp()==false)return;
let postData = {
  id:this.idp_.id,
  id_competencia:this.idp_.skill,
  actividades:this.idp_.trainig,
  fecha:this.idp_.fecha,
  costo:this.idp_.costos,
  resultado:this.idp_.resultados,
  estado:this.idp_.estatus   
};
this.authService.service("/api/upd_idp",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);              
      this.idp_v=true;
      swal.fire('Ok', '', 'success');
      this.ls_idp(this.hidCvePersona);
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('API incorrecta! idp', '', 'error');
    });  
}
fn_insidp(){
  if(this.valida_idp()==false)return;
  let postData = {
      id:this.idp_.id,
      id_persona:this.hidCvePersona,
      id_competencia:this.idp_.skill,
      actividades:this.idp_.trainig,
      fecha:this.idp_.fecha,
      costo:this.idp_.costos,
      resultado:this.idp_.resultados,
      estado:this.idp_.estatus    
  };
  this.authService.service("/api/ins_idp",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.idp_v=true;        
        this.ls_idp(this.hidCvePersona);
        swal.fire('Ok', '', 'success');
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  

}
idp_=
  {
    id:0,
    skill:0,
    trainig:"",
    fecha:"",
    costos:0,
    resultados:"",
    estatus:'A'
  };
  idp_v:boolean=true;
fn_edit_idp(itm){
  this.idp_v=false;
  this.idp_.id=itm.id;
  this.idp_.skill=itm.id_competencia;
  this.idp_.trainig=itm.actividades;
  try {
    this.idp_.fecha=itm.fecha.substring(0,10);  
  } catch (error) {
    this.idp_.fecha="";
  }
  
  this.idp_.costos=itm.costo;
  this.idp_.resultados=itm.resultado;
  this.idp_.estatus=itm.estado;
  this.idp_a=true;
}
idp_a:boolean=true;
competencias;
competencias_;
evaluacion_;
competence_v:boolean=true;
competence_v_t:boolean=true;
fn_filter(){
  this.ls_competencias();
}
rpt_;
apply_filter(){
  let postData = {id_competencia:Number(this.competencias_),evaluacion:this.evaluacion_};
  //console.log(postData);
  this.authService.service("/api/get_personas_filter",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
          //console.log(data);
          this.rpt_=data;
          //this.competencias=data;
          //console.log(res);          
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  
}

ls_competencias_caliper(){
  let postData = { 
    id_cliente:localStorage.getItem("id_cliente"),
  } 
  this.authService.service("/api/get_competencia_cliente",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          
          this.competencias_=data;
          //console.log(res);          
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  
}
ls_competencias_trinity(){
  let postData = {};
  this.authService.service("/api/get_competencia_trinity",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          
          this.competencias_=data;
          //console.log(res);          
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  
}


ls_competencias(){
  let postData = {};
  this.authService.service("/api/get_allcompetencias",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          this.competencias=data;
          this.competencias_=data;
          //console.log(res);          
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  
}
ls_idp(id_){
  let postData = {id_persona:id_}
  this.authService.service("/api/get_idp",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          this.idp=data;
          //console.log(res);          
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! idp', '', 'error');
      });  

}
nva_competencia(){
  this.competence_v=false;
}
nva_competencia_t(){
  this.competence_v_t=false;
  this.comp_ev=false;
}

fn_competencias_t(itm){
  this.persona.nombre=itm.nombre;
  this.competence_v_t=true;
  this.per_competencia_t=[];
  this.hidCvePersona=itm.id;
  this.ls_competencia_trinity();
  this.ls_percompetencias_t();
  //this.selgpoComp=0;
  //this.selComp=0;
  
}
sel_t;
ins_competencia_t(){
  let postData = {
    id_persona:this.hidCvePersona,
    id_competencia:this.sel_t,
    id_role_card:0
  };
  if(this.sel_t==0)return;
  this.authService.service("/api/ins_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias_t();
        this.competence_v_t=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}

selComp_desirable;
eval_desirable;
ins_competencia_desirable(){
  let postData = {
    id_persona:0,
    id_competencia:this.selComp_desirable,
    id_role_card:this.exp.id,
    evaluacion:Number(this.eval_desirable)?this.eval_desirable:0};
  if(this.selComp_desirable==0)return;
  this.authService.service("/api/ins_percompetencia_desirable",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias_t();
        if(this.tipo_c=="CALIPER"){
          this.dc_caliper();
        }else{
          this.dc_trinity();
        }
        
        this.competence_v_t=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
    
      let postData2 = {
        id_persona:this.hidCvePersona,
        id_competencia:this.selComp_desirable,
      };
      
      this.authService.service("/api/ins_percompetencia",postData2)
      .then(
          data => {
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('API incorrecta!', '', 'error');
          });

}


per_competencia_t;
ls_percompetencias_t(){
  let postData = {id_persona:this.hidCvePersona};
  this.authService.service("/api/get_per_competencia_trinity",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          this.per_competencia_t=data;
        }        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}

Comp_t;
ls_competencia_trinity(){
  let postData = {}
  this.authService.service("/api/get_competencia_trinity",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
        //this.txbrlc="";
        //console.log(res);
        this.Comp_t=data;
        }        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta! trinity', '', 'error');
      });

}
fn_competencias(itm){
  this.persona.nombre=itm.nombre;
  this.competence_v=true;
  this.per_competencia=[];
  this.hidCvePersona=itm.id;
  this.ls_gpocompetencia();
  this.ls_percompetencias();
  this.selgpoComp=0;
  this.selComp=0;
}
gpo_competencia;

ls_gpocompetencia(){
  let postData = {
    id_cliente:localStorage.getItem("id_cliente")
  }
  this.authService.service("/api/get_gpocompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
        this.txbrlc="";
        //console.log(res);
        this.gpo_competencia=data;
        }        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
per_competencia;


ls_percompetencias(){
  let postData = {id_persona:this.hidCvePersona};
  this.authService.service("/api/get_per_competencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          this.per_competencia=data;
        }        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
selgpoComp:number=0;
del_percomp(id){
  if (!confirm("The data will be saved!"))return;
  let postData = {id_:id};
  this.authService.service("/api/del_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                    
        this.ls_percompetencias();                
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });

}
del_percomp_t(id){
  if (!confirm("The data will be saved!"))return;
  let postData = {id_:id};
  this.authService.service("/api/del_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.ls_percompetencias_t();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });

}
comp_ev:boolean=false;
comp_evaluacion;
comp_descripcion;
comp_evaluacion_t;
comp_descripcion_t;
hidcompetenciaid;
edt_percomp(itm){
  //console.log(itm);
  this.hidcompetenciaid=itm.id;
  this.comp_ev=true;
  this.competence_v=false;
  this.comp_evaluacion=itm.evaluacion; 
  this.comp_descripcion=itm.descripcion;
  this.year_comp=0;
}
edt_percomp_t(itm){
  //console.log(itm);
  this.hidcompetenciaid=itm.id;
  this.comp_ev=true;
  this.competence_v_t=false;
  this.comp_evaluacion_t=itm.evaluacion; 
  this.comp_descripcion_t=itm.descripcion;
  this.year_comp=0;
}
selComp:number=0;
cance_competencia(){
  this.competence_v=true;
}
cance_competencia_t(){
  this.competence_v_t=true;
}
_box={
  titulo:"",
  contenido:"",
  numero:0
};
nineb=0;
per_box_;
perbox(id){
  let postData = {
    id_persona:id
  };
  this.authService.service("/api/get_per_box",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);   
        this.per_box_=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
          this.loading=false;
      });

}
fn_box(itm){
  //console.log(itm);
  this.persona.id=itm.id;
  this.persona.nombre=itm.nombre;
  this.perbox(itm.id);
  this.nineb=0;
  
}
id_perosna_box=0;
year_comp=0;
view_nineb(t){
  let postData = {
    id_persona:this.persona.id,
    id_evaluador:this.id_perosna_box
  };
  //console.log(postData);
 var a="";
  switch (t) {
    case 'C':
      a="/api/nine_box";
      break;
    case 'L':
      a="/api/nine_box_last";
        break;  
    default:
      break;
  }
  this.authService.service(a,postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //console.log(res);
        this.nineb=res[0].nineb;
        //this._eval_=res;
        this.loading=false;
        this._box.titulo="Nine Box ";
        this._box.contenido="Medición y evaluación de Competencias  "+
          " <br>Competences="+res[0].competence+""+
          " <br>Goals="+res[0].goals+"%";
        this._box.numero=1;

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
          this.loading=false;
      });

}
_eval_;
v_eval(itm){
  this.loading=true
  let postData = {
    id_per_competencia:itm.id
  };
  
  
  
  this.authService.service("/api/get_evaluacion_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //console.log(res);
        this._eval_=res;
        this.loading=false;
        

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
          this.loading=false;
      });
}

evalua_competencia_t(){
  let postData = {
    id_per_competencia:this.hidcompetenciaid,
    id_evaluador:localStorage.getItem("usuario"),
    evaluacion:this.comp_evaluacion_t,
    descripcion:this.comp_descripcion_t
  };  
  //console.log(postData);
  this.authService.service("/api/eval_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias();
        this.competence_v=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}

evalua_competencia(){
  
  let postData = {
    id_per_competencia:this.hidcompetenciaid,
    id_evaluador:localStorage.getItem("usuario"),
    evaluacion:this.comp_evaluacion,
    descripcion:this.comp_descripcion,
    anio:this.year_comp
  };  
  //console.log(postData);
  this.authService.service("/api/eval_percompetencia2",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias();
        this.competence_v=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
upd_competencia(){ 
  let postData = {
    id_percompetencia:this.hidcompetenciaid,
    evaluacion:this.comp_evaluacion,
    descripcion:this.comp_descripcion
  };
  //console.log("..");
  //console.log(postData);
  this.authService.service("/api/upd_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias();
        this.competence_v=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
upd_competencia_t(){ 
  let postData = {
    id_percompetencia:this.hidcompetenciaid,
    evaluacion:this.comp_evaluacion_t,
    descripcion:this.comp_descripcion_t
  };
  //console.log("..");
  //console.log(postData);
  this.authService.service("/api/upd_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias_t();
        this.competence_v_t=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}


ins_competencia(){
  let postData = {
    id_persona:this.hidCvePersona,
    id_competencia:this.selComp,
    id_role_card:0
  };
  if (this.selComp==0 || this.selComp==undefined)return;  
  this.authService.service("/api/ins_percompetencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.ls_percompetencias();
        this.competence_v=true;
        swal.fire('Ok', '', 'success');

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
selgpo(itm){
  this.ls_competencia(itm);
}
competencia;
ls_competencia(g){
  let postData = {id_gpo_competencia:g}
  this.authService.service("/api/get_competencia",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
        this.txbrlc="";
        this.competencia=data;
        }        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}

txbper:any;
txbrlc:any;
busrlc(){
  if (this.txbrlc.length==0)return;
  let postData = {
    persona:this.txbrlc,
    id_role:this.persona.id_role,
    id_cliente:localStorage.getItem("id_cliente")
  }
  //console.log(postData);
  this.authService.service("/api/bus_persona",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
        this.txbrlc="";
        //console.log(res);
        this.per=data;
        }        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
busper(){
  if (this.txbper.length==0)return;
  let postData = {
    persona:this.txbper,
    id_role:this.persona.id_role
    ,id_cliente:localStorage.getItem("id_cliente")}
  this.authService.service("/api/bus_persona",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          this.txbper="";
        //console.log(res);
        this.per=data;
        }        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });
}
fn_lider(itm){
  if(confirm("Confirm to this person as a lider of client?")== false)return;
  this.loading=true;
  let postData = {
    id_role:itm.id_role,
    id_cliente:localStorage.getItem("id_cliente"),
    
  }
  //this.per=[];
  console.log(postData);
  this.authService.service("/api/lider_cli",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);   
      for(var i=0;i<this.per.length;i++){
        if(this.per[i].id==itm.id){
          this.per[i].lider=1;
        }else{
          this.per[i].lider=0;
        }
      }
      this.loading=false;
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('API incorrecta!', '', 'error');
        this.loading=false;
    });
}
fn_chart_org(itm){  
  this.loading=true;
  let postData = {
    id_persona:itm.id,
    c:itm.director==0?1:0
  }
  //this.per=[];
  console.log(itm);
  console.log(postData);
  this.authService.service("/api/chart_org_per",postData)
.then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);   
      for(var i=0;i<this.per.length;i++){
        if(this.per[i].id==itm.id){
          this.per[i].director=itm.director==0?1:0;
        }
      }
      //this.ls_persona();
      this.loading=false;
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        swal.fire('API incorrecta!', '', 'error');
        this.loading=false;
    });
}

ls_persona(){
    this.loading=true;
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    }
    this.per=[];
    console.log(postData);
    this.authService.service("/api/get_persona",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.per=data;
        this.loading=false;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
          this.loading=false;
      });
  }
  pro:any;
  ls_proceso(){
    let postData = {
      id_raci:0
    }
  this.authService.service("/api/get_proceso",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        if (res.length!=0)
        {
          this.pro=data;
          //console.log(res);          
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });  

}


public URL:any;
public evento:any;
public img1:any;
public urlwebimg:any;
public msg_foto:any;
 ext_(f:any) {
   //console.log(f);
   var c:string[]=f.split("/");
  return c[(c.length-1)]; 
}
fileToUpload: File = null;
onSelectFile(event,idx) {
  //console.log(event);
  this.URL = event.target.files;
  this.fileToUpload = event.target.files[0];
}
uploadFileToActivity(){
//console.log("upload");
 
  if (this.fileToUpload) {
    var reader = new FileReader();
    
    reader.readAsDataURL(this.fileToUpload); // read file as data url
    const file = this.fileToUpload;
    
    reader.onload = (event) => { 
      this.URL = reader.result;

      var tmpDate = new Date();     //  Wed Oct 16 2013 12:37:29 GMT+0200
      var now = tmpDate.getTime();
      let data: any = {
        cveentevt: 1,
        name: now + '.' + this.ext_(file.type),
        firma: this.URL,
        idx: 1,
        id_persona:this.hidCvePersona
      }
      
      
      this.persona.foto=data.name;
      data.TYPE = 'pdf';
      data.FILENAME = 'files/' + now + '.pdf',
      
       //this.loading =true;
      //console.log(data);
        
        this.authService.upImagen(data).then(res => {
          var mm = JSON.stringify(res)
          var dd = JSON.parse(mm)
          this.msg_foto="<span class=green>✔</span> ";
          //console.log("guardado");
          //this.img1.id = res[0].cveevtanx;
          //this.img1.url = this.urlwebimg +  now + ".png";
          this.txt_fot=  now + ".png" 
          //this.loading =false;
            //this.PDF =  dd.detailed_message            
          //swal.fire('DOCUMENTO SE GUARDO EXITOSAMENTE','DOCUMENTO SE GUARDO EXITOSAMENTE','success')
            // console.log(dd.detailed_message)              

        },error => {
          this.msg_foto=" <span style=color:red;>X error</span> ";
        }
        )
      }
    }
}
txt_fot;


/*
selectedFile: ImageSnippet;
processFile(imageInput: any) {
  const file: File = imageInput.files[0];
  const reader = new FileReader();
  reader.addEventListener('load', (event: any) => {
  this.selectedFile = new ImageSnippet(event.target.result, file);

    this.authService.uploadImage("/api/upload",this.selectedFile.file).then(
      (res) => {
      
      },
      (err) => {
      
      })
  });
}*/
}
